import { render } from "./DatabaseStats.vue?vue&type=template&id=7fa04ecf&scoped=true"
import script from "./DatabaseStats.vue?vue&type=script&lang=js"
export * from "./DatabaseStats.vue?vue&type=script&lang=js"

import "./DatabaseStats.vue?vue&type=style&index=0&id=7fa04ecf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fa04ecf"]])

export default __exports__